<ngb-pagination
  [collectionSize]="totalCount"
  [page]="page"
  (pageChange)="onPageChange($event)"
  [maxSize]="paginationMaxSize"
  [pageSize]="pageSize"
>
</ngb-pagination>
